import { graphql } from '@/gql'

export const StaffingAgencyMetricsQuery = graphql(/* GraphQL */ `
  query StaffingAgencyMetrics($accounts: [ID!]!) {
    sharedJobs: jobShares(accountTypes: [RECRUITER], isActive: true) {
      paginatorInfo {
        total
      }
    }

    activePlacements: hires(accounts: $accounts, activeStatus: [ACTIVE]) {
      paginatorInfo {
        total
      }
    }

    pendingBills: paymentRequests(
      accounts: $accounts
      statuses: [UNAPPROVED]
    ) {
      paginatorInfo {
        total
      }
    }

    candidates: recruiterCandidates(accounts: $accounts) {
      paginatorInfo {
        total
      }
    }

    candidatesNeedingAction: recruiterCandidates(
      accounts: $accounts
      hasPendingActions: true
    ) {
      paginatorInfo {
        total
      }
    }
  }
`)
